module.exports = __webpack_public_path__ + "static/img/selectbox_arrow_r_sel.8dd32f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/selectbox_arrow_r_sel.svg
// module id = 8K6S
// module chunks = 10